var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-actions"},[_c('div',{staticClass:"card card-default"},[_c('div',{staticClass:"card-header"},[_c('i',{class:_vm.icon}),_c('strong',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"card-body"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }